// extracted by mini-css-extract-plugin
module.exports = {"RadioGroup":"RadioGroup_RadioGroup__2aWeV","RadioGroup__legend":"RadioGroup_RadioGroup__legend___QUzr","RadioGroup__radios":"RadioGroup_RadioGroup__radios__n1Y75"};